import { resolveInitialMarketplace } from "./selectedMarketplace";

export function getInitialSelectedMarketplaceState() {
  return {
    selectedMarketplace: resolveInitialMarketplace(
      typeof window === "undefined" ? "" : window.location.pathname
    ),
  };
}

// Считается один раз при создании store, по адресу, с которым открыли кабинет.
const initialSelectedMarketplaceState = getInitialSelectedMarketplaceState();

const selectedMarketplaceReducer = (
  state = initialSelectedMarketplaceState,
  action
) => {
  if (action.type === "SET_SELECTED_MARKETPLACE") {
    if (action.value !== "wb" && action.value !== "ozon") return state;
    if (state.selectedMarketplace === action.value) return state;

    return {
      ...state,
      selectedMarketplace: action.value,
    };
  }

  return state;
};

export default selectedMarketplaceReducer;
